var ViewMode;
(function(ViewMode) {
    ViewMode["ADD"] = "ADD";
    ViewMode["DELETE"] = "DELETE";
    ViewMode["EDIT"] = "EDIT";
})(ViewMode || (ViewMode = {}));

export { ViewMode };
//# sourceMappingURL=state.js.map
